// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DtaUploadType } from './dta-upload-type';
import {
    DtaUploadTypeFromJSON,
    DtaUploadTypeFromJSONTyped,
    DtaUploadTypeToJSON,
    DtaUploadTypeToJSONTyped,
} from './dta-upload-type';

/**
 * 
 * @export
 * @interface UploadDtaFileRequest
 */
export interface UploadDtaFileRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadDtaFileRequest
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof UploadDtaFileRequest
     */
    upload_id: string;
    /**
     * 
     * @type {DtaUploadType}
     * @memberof UploadDtaFileRequest
     */
    upload_type: DtaUploadType;
    /**
     * 
     * @type {string}
     * @memberof UploadDtaFileRequest
     */
    vendor_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadDtaFileRequest
     */
    vendor_name?: string;
}



/**
 * Check if a given object implements the UploadDtaFileRequest interface.
 */
export function instanceOfUploadDtaFileRequest(value: object): value is UploadDtaFileRequest {
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    if (!('upload_id' in value) || value['upload_id'] === undefined) return false;
    if (!('upload_type' in value) || value['upload_type'] === undefined) return false;
    return true;
}

export function UploadDtaFileRequestFromJSON(json: any): UploadDtaFileRequest {
    return UploadDtaFileRequestFromJSONTyped(json, false);
}

export function UploadDtaFileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadDtaFileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'file_name': json['file_name'],
        'upload_id': json['upload_id'],
        'upload_type': DtaUploadTypeFromJSON(json['upload_type']),
        'vendor_id': json['vendor_id'] == null ? undefined : json['vendor_id'],
        'vendor_name': json['vendor_name'] == null ? undefined : json['vendor_name'],
    };
}

export function UploadDtaFileRequestToJSON(json: any): UploadDtaFileRequest {
    return UploadDtaFileRequestToJSONTyped(json, false);
}

export function UploadDtaFileRequestToJSONTyped(value?: UploadDtaFileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_name': value['file_name'],
        'upload_id': value['upload_id'],
        'upload_type': DtaUploadTypeToJSON(value['upload_type']),
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
    };
}
